module.exports = __webpack_public_path__ + "static/media/24-8.c0f96ad4.mp3";